import { BillingEvent } from '@epilot/customer-portal-client'

export const MOCK_PAYMENTS: { results: BillingEvent[]; hits: number } = {
  results: [
    {
      contract: {
        $relation: [
          {
            entity_id: '78d3639c-ef63-4517-9942-3407dda87de7'
          }
        ]
      },
      type: 'installment',
      billing_amount: 7300,
      billing_amount_currency: 'EUR',
      billing_amount_decimal: '73.00',
      _schema: 'billing_event',
      due_date: '2025-06-31T18:00:00.000000',
      paid_date: '2025-06-31T18:00:00.000000',
      _tags: ['dont-change'],
      _id: '93965c7a-f599-4ed9-965d-e7954dcae7fa',
      _org: '16246022',
      _created_at: '2025-05-23T09:12:59.574Z',
      _updated_at: '2025-05-23T09:12:59.574Z',
      _title: 'installment 31.5.2025',
      booking_date: '2025-05-31T18:00:00.000000',
      _relations: [
        {
          entity_id: '8b37a04c-ac8a-4598-abcc-dc4fe2634a58'
        }
      ],
      _messages: {}
    },
    {
      contract: {
        $relation: [
          {
            entity_id: '78d3639c-ef63-4517-9942-3407dda87de7'
          }
        ]
      },
      type: 'installment',
      billing_amount: 7300,
      billing_amount_currency: 'EUR',
      billing_amount_decimal: '73.00',
      _schema: 'billing_event',
      due_date: '2025-05-31T18:00:00.000000',
      paid_date: '2025-05-31T18:00:00.000000',
      _tags: ['dont-change'],
      _id: 'cf5620df-df67-48f4-951a-0a281922b750',
      _org: '16246022',
      _created_at: '2025-05-23T09:15:15.646Z',
      _updated_at: '2025-05-23T09:15:15.646Z',
      _title: 'installment 31.5.2025',
      booking_date: '2025-05-31T18:00:00.000000',
      _relations: [
        {
          entity_id: '78d3639c-ef63-4517-9942-3407dda87de7'
        }
      ],
      _messages: {}
    },
    {
      contract: {
        $relation: [
          {
            entity_id: '78d3639c-ef63-4517-9942-3407dda87de7'
          }
        ]
      },
      type: 'installment',
      billing_amount: 7300,
      billing_amount_currency: 'EUR',
      billing_amount_decimal: '73.00',
      _schema: 'billing_event',
      due_date: '2025-04-30T18:00:00.000000',
      paid_date: '2025-04-30T18:00:00.000000',
      _tags: ['dont-change'],
      _id: '034fb9e9-2e6d-4e21-888f-90fb2a1c90c4',
      _org: '16246022',
      _created_at: '2025-05-23T09:14:51.543Z',
      _updated_at: '2025-05-23T09:14:51.543Z',
      _title: 'installment 30.4.2025',
      booking_date: '2025-04-30T18:00:00.000000',
      _relations: [
        {
          entity_id: '78d3639c-ef63-4517-9942-3407dda87de7'
        }
      ],
      _messages: {}
    },
    {
      contract: {
        $relation: [
          {
            entity_id: '78d3639c-ef63-4517-9942-3407dda87de7'
          }
        ]
      },
      type: 'installment',
      billing_amount: 7300,
      billing_amount_currency: 'EUR',
      billing_amount_decimal: '73.00',
      _schema: 'billing_event',
      due_date: '2025-03-30T18:00:00.000000',
      paid_date: '2025-03-30T18:00:00.000000',
      _tags: ['dont-change'],
      _id: '8166fab7-1de0-4c4d-8676-59fb8f685f8e',
      _org: '16246022',
      _created_at: '2025-05-23T09:12:41.480Z',
      _updated_at: '2025-05-23T09:12:41.480Z',
      _title: 'installment 30.4.2025',
      booking_date: '2025-04-30T18:00:00.000000',
      _relations: [
        {
          entity_id: '8b37a04c-ac8a-4598-abcc-dc4fe2634a58'
        }
      ],
      _messages: {}
    },
    {
      contract: {
        $relation: [
          {
            entity_id: '78d3639c-ef63-4517-9942-3407dda87de7'
          }
        ]
      },
      type: 'installment',
      billing_amount: 7300,
      billing_amount_currency: 'EUR',
      billing_amount_decimal: '73.00',
      _schema: 'billing_event',
      due_date: '2025-02-26T18:00:00.000000',
      paid_date: '2025-02-26T18:00:00.000000',
      _tags: ['dont-change'],
      _id: '7de6d829-72e5-4450-85b8-b442bf409506',
      _org: '16246022',
      _created_at: '2025-01-23T09:12:25.867Z',
      _updated_at: '2025-01-23T09:12:25.867Z',
      _title: 'installment 31.3.2025',
      booking_date: '2025-03-31T18:00:00.000000',
      _relations: [
        {
          entity_id: '8b37a04c-ac8a-4598-abcc-dc4fe2634a58'
        }
      ],
      _messages: {}
    }
  ],
  hits: 5
}
